import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@material-ui/core';

import { useMap } from '../CustomHooks/useMap';
import SampleEditView from './SampleEditView';
import MapEditor from './MapEditor';

const MapEditView = ({
  open,
  setOpen,
  sectionData,
  mapData,
  saveMapCoordinates,
  updateMapCoordinates,
  deleteMapCoordinates,
  samples,
  samplesData,
  dropDownOptions,
  handleAction,
  handleSampleData,
  boundaryAlreadyExists,
  onMapClose, // Callback to create/update geofence when map closes
}) => {
  const { mapState, mapActions } = useMap({ mapData, sectionData, open, isMapLoaded: true });

  const handleClose = async () => {
    // Call geofence update callback if provided
    if (onMapClose) {
      await onMapClose(mapState);
    }

    mapActions.setMode(null);
    setOpen(false);
  };

  return (
    <>
      <Dialog open={open} maxWidth="xl" onClose={handleClose} disableAutoFocus disableEnforceFocus>
        <DialogTitle>Geo Locations</DialogTitle>

        <DialogContent style={{ width: '90vw', height: '80vh' }}>
          <Box display="flex" flexDirection="row">
            <MapEditor
              mapState={mapState}
              mapActions={mapActions}
              mapData={mapData}
              saveMapCoordinates={saveMapCoordinates}
              updateMapCoordinates={updateMapCoordinates}
              deleteMapCoordinates={deleteMapCoordinates}
              boundaryAlreadyExists={boundaryAlreadyExists}
            />
            <Box flex={6} sx={{ width: '100%', overflowY: 'auto', paddingLeft: 2 }}>
              <SampleEditView
                pins={mapState?.pins}
                samplePoints={samples}
                samplesData={samplesData}
                dropDownOptions={dropDownOptions}
                handleAction={handleAction}
                handleSampleData={handleSampleData}
              />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="primary">
            Close
          </Button>
          {/* <Button onClick={() => { }} variant="contained" color="primary">
            Save
          </Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MapEditView;
